import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Briefcase } from 'lucide-react';
import LazyImage from './LazyImage';

export default function IDCard3D() {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      {/* Tali Gantung */}
      <motion.div
        animate={{ rotate: [-2, 2, -2] }}
        transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
        className="w-1 h-24 bg-gradient-to-b from-gray-600 to-gray-800 rounded-full relative"
        style={{
          boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
        }}
      >
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-4 h-4 bg-gray-700 rounded-full border-2 border-gray-500"></div>
      </motion.div>

      {/* ID Card */}
      <motion.div
        animate={{
          rotateY: [0, 5, 0, -5, 0],
          rotateX: [0, 2, 0, -2, 0],
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        className="relative"
        style={{
          perspective: '1000px',
          transformStyle: 'preserve-3d',
        }}
      >
        <motion.div
          whileHover={{ scale: 1.02, rotateY: 10 }}
          className="glass-card p-6 w-80 relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, rgba(14, 165, 233, 0.1) 0%, rgba(16, 185, 129, 0.1) 100%)',
            boxShadow: '0 8px 32px 0 rgba(14, 165, 233, 0.3), 0 0 20px rgba(14, 165, 233, 0.2)',
            border: '2px solid rgba(14, 165, 233, 0.3)',
          }}
        >
          {/* Neon Border Animation */}
          <div className="absolute inset-0 rounded-2xl animate-neon-pulse" style={{
            background: 'linear-gradient(90deg, transparent, rgba(14, 165, 233, 0.5), transparent)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s infinite',
          }}></div>

          {/* Header */}
          <div className="relative z-10 text-center mb-4">
            <h3 className="text-sm font-bold text-neon-blue mb-1">DIGITAL ID CARD</h3>
            <div className="h-px bg-gradient-to-r from-transparent via-neon-blue to-transparent"></div>
          </div>

          {/* Photo */}
          <div className="relative z-10 flex justify-center mb-4">
            <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-neon-blue shadow-[0_0_20px_rgba(14,165,233,0.6)]">
              <LazyImage
                src="/images/profile.jpg"
                alt="Mahin Utsman Nawawi"
                className="w-full h-full"
                width={128}
                height={128}
                priority={true} // Hero image should be priority
              />
            </div>
          </div>

          {/* Info */}
          <div className="relative z-10 space-y-3">
            <div className="text-center">
              <h2 className="text-xl font-bold text-white mb-1">Mahin Utsman Nawawi</h2>
              <p className="text-sm text-neon-green font-semibold">S.H, C.D.M.P</p>
            </div>

            <div className="h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent my-3"></div>

            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2 text-gray-300">
                <Briefcase size={16} className="text-neon-blue" />
                <span>No-Code & AI Prompt Specialist</span>
              </div>
              <div className="flex items-center gap-2 text-gray-300">
                <Mail size={16} className="text-neon-blue" />
                <span className="text-xs">nawawnawawimahinutsman@gmail.com</span>
              </div>
              <div className="flex items-center gap-2 text-gray-300">
                <Phone size={16} className="text-neon-blue" />
                <span>+62 813 2044 2174</span>
              </div>
              <div className="flex items-center gap-2 text-gray-300">
                <MapPin size={16} className="text-neon-blue" />
                <span>Indonesia</span>
              </div>
            </div>
          </div>

          {/* Footer Tagline */}
          <div className="relative z-10 mt-4 pt-3 border-t border-gray-700">
            <p className="text-center text-xs italic text-neon-green">
              "Law & Tech in Harmony – Dari Pasal ke Pixel"
            </p>
          </div>
        </motion.div>
      </motion.div>

      <style>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
      `}</style>
    </div>
  );
}
